<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyStatus="filterProps.status"
      :keyType="filterProps.type"
      :keyClickType="filterProps.clickType"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyStatus="filterProps.status"
        :keyType="filterProps.type"
        :keyClickType="filterProps.clickType"
        @clearKey="clearKey"
        @addNew="addNew"
      />
      <router-view
        v-if="isSysRights('SupplierMarket.findBySupplier')"
        :first_loading="firstLoading"
        :items="items"
        @deleteAD="deleteAD"
        @editAD="editAD"
        @move="move"
        @openMarketPro="openMarketPro"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/mall-marketing/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
      <Modal
        :modalId="'modalNewAD'"
        :home="false"
        :loading="modalNewAD.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("mall.添加商品组合") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <form>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.类型：") }}
                </label>
                <div class="col-md-8 col-sm-12 pd-0 mg-l-10">
                  <div class="d-flex align-items-center">
                    <select
                      class="form-control form-control-sm"
                      v-model="modalNewAD.type"
                    >
                      <option value="">{{ $t("mall.类型") }}</option>
                      <option
                        v-for="(s, k) in $dict.markettype"
                        :key="k"
                        :value="k"
                      >
                        {{ $t(s) }}
                      </option>
                    </select>
                  </div>
                  <div class="mg-t-5 tx-12 tx-danger" v-if="modalNewAD.type">
                    {{ $t(marketTypeList[modalNewAD.type]) }}
                  </div>
                </div>
              </div>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.点击类型：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <select
                    class="form-control form-control-sm"
                    v-model="modalNewAD.clickType"
                  >
                    <option value="">{{ $t("mall.点击类型") }}</option>
                    <option
                      v-for="(s, k) in $dict.marketclickType"
                      :key="k"
                      :value="k"
                    >
                      {{ $t(s) }}
                    </option>
                  </select>
                </div>
              </div>
              <template v-if="modalNewAD.clickType == 1">
                <div class="form-group row mg-b-10">
                  <label
                    class="col-md-3 col-form-label form-control-sm text-right"
                  >
                    {{ $t("mall.关键词：") }}
                  </label>
                  <div
                    class="
                      col-md-8 col-sm-12
                      d-flex
                      align-items-center
                      pd-0
                      mg-l-10
                    "
                  >
                    <input
                      v-model="modalNewAD.productName"
                      type="text"
                      :placeholder="$t('mall.请输入关键词')"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
                <div class="form-group row mg-b-10">
                  <label
                    class="col-md-3 col-form-label form-control-sm text-right"
                  >
                    {{ $t("mall.价格范围段：") }}
                  </label>
                  <div
                    class="
                      col-md-8 col-sm-12
                      d-flex
                      align-items-center
                      pd-0
                      mg-l-10
                    "
                  >
                    <input
                      v-model="modalNewAD.priceRange1"
                      type="text"
                      :placeholder="$t('mall.请输入价格')"
                      class="form-control form-control-sm wd-100"
                    />
                    <span class="mg-x-10">---</span>
                    <input
                      v-model="modalNewAD.priceRange2"
                      type="text"
                      :placeholder="$t('mall.请输入价格')"
                      class="form-control form-control-sm wd-100"
                    />
                  </div>
                </div>
                <div class="form-group row mg-b-10">
                  <label
                    class="col-md-3 col-form-label form-control-sm text-right"
                  >
                    {{ $t("mall.商品标签：") }}
                  </label>
                  <div class="col-md-7 d-flex align-items-center pd-0">
                    <div style="word-break: break-all" class="pd-l-10">
                      {{ modalNewAD.cIdName ? modalNewAD.cIdName : "---" }}
                    </div>
                  </div>
                  <div class="col-md-2">
                    <a
                      href="javascript:;"
                      class="tx-info mg-l-20"
                      @click="modalNewADLabel"
                      >{{
                        modalNewAD.cIdName
                          ? $t("mall.修改标签")
                          : $t("mall.添加标签")
                      }}</a
                    >
                  </div>
                </div>
              </template>
              <template v-if="modalNewAD.clickType == 2">
                <div class="form-group row mg-b-10">
                  <label
                    class="col-md-3 col-form-label form-control-sm text-right"
                  >
                    {{ $t("mall.选择商品：") }}
                  </label>
                  <div
                    class="
                      col-md-8 col-sm-12
                      d-flex
                      align-items-center
                      pd-0
                      mg-l-10
                    "
                  >
                    <div style="word-break: break-all" class="pd-l-10">
                      {{ $t("mall.已选择") }}{{ modalNewAD.products.length
                      }}{{ $t("mall.个商品") }}
                    </div>
                    <a
                      href="javascript:;"
                      class="tx-info mg-l-20"
                      @click="modalMarketPro"
                      >{{ $t("mall.选择商品") }}</a
                    >
                  </div>
                </div>
              </template>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.状态：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <select
                    class="form-control form-control-sm"
                    v-model="modalNewAD.status"
                  >
                    <option value="">{{ $t("mall.状态") }}</option>
                    <option
                      v-for="(s, k) in $dict.marketStatus"
                      :key="k"
                      :value="k"
                    >
                      {{ $t(s) }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.标题：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <input
                    v-model="modalNewAD.title"
                    type="text"
                    :placeholder="$t('mall.请输入标题')"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
            </form>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveNewAD()"
              >
                {{ $t("mall.确定") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("mall.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalMallLabel'"
        :home="false"
        :loading="modalMallLabel.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("mall.选择商品标签") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="form-group row mg-b-10">
              <p class="col-12 mg-b-0">{{ $t("mall.选择要加入的标签") }}:</p>
            </div>
            <div class="form-group row mg-b-10">
              <div
                class="col-12"
                v-for="(item, index) in modalMallLabel.list"
                :key="index"
              >
                <label class="c-checkbox-wrap">
                  <input
                    type="radio"
                    :value="item.id"
                    v-model="modalNewAD.cId"
                  />
                  <div class="c-checkbox">
                    <i class="ion-android-checkbox-blank"></i>
                    <span style="word-break: break-all">{{ item.name }}</span>
                  </div>
                </label>
                <div
                  class="col-12"
                  v-if="item.chlidren && item.chlidren.length > 0"
                >
                  <label
                    v-for="stock in item.chlidren"
                    :key="stock.id"
                    class="c-checkbox-wrap"
                  >
                    <input
                      type="radio"
                      :value="stock.id"
                      v-model="modalNewAD.cId"
                    />
                    <div class="c-checkbox">
                      <i class="ion-android-checkbox-blank"></i>
                      <span style="word-break: break-all">{{
                        stock.name
                      }}</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveNewADLabel()"
              >
                {{ $t("mall.确定") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("mall.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalMarketProduct'"
        :home="false"
        :loading="modalMarketProduct.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("mall.选择商品") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="d-flex">
              <div
                class="c-14 pd-r-10"
                style="border-right: 1px solid #ddd; padding-right: 10px"
              >
                <p class="tx-gray-900 mg-b-10">{{ $t("mall.我的供应信息") }}</p>
                <div class="d-flex">
                  <input
                    type="text"
                    v-model="modalMarketProduct.keySpu"
                    :placeholder="$t('mall.请输入SPU')"
                    class="form-control form-control-sm wd-150 mg-r-10"
                  />
                  <input
                    type="text"
                    v-model="modalMarketProduct.keyName"
                    :placeholder="$t('mall.请输入商品名称')"
                    class="form-control form-control-sm wd-150 mg-r-10"
                  />
                  <a
                    href="javascript:;"
                    class="btn btn-sm btn-info"
                    @click="filtrateModal"
                    >{{ $t("mall.筛选") }}</a
                  >
                </div>
                <div
                  class="form-group row mg-t-10"
                  v-show="
                    modalMarketProduct.keySpuCopy != '' ||
                    modalMarketProduct.keyNameCopy != ''
                  "
                >
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-start
                      pd-x-15
                    "
                  >
                    <div class="clear-key">
                      <a
                        v-show="modalMarketProduct.keySpuCopy"
                        href="javascript:;"
                        class="mg-r-15"
                        @click="clearKeyModal('spu')"
                      >
                        SPU：
                        <span class="mg-r-10">{{
                          modalMarketProduct.keySpuCopy
                        }}</span>
                        <i class="fa fa-close"></i>
                      </a>
                      <a
                        v-show="modalMarketProduct.keyNameCopy"
                        href="javascript:;"
                        class="mg-r-15"
                        @click="clearKeyModal('name')"
                      >
                        {{ $t("mall.名称：") }}
                        <span class="mg-r-10">{{
                          modalMarketProduct.keyNameCopy
                        }}</span>
                        <i class="fa fa-close"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="mg-t-10">
                  <div
                    style="border-bottom: 1px solid #ddd"
                    class="d-flex tx-12 align-items-center pd-y-5"
                    v-for="(item, index) in modalMarketProduct.items"
                    :key="item.id"
                  >
                    <a
                      class="mg-r-10 img-wrap d-block"
                      href="javascript:;"
                      v-lazy:background-image="item.majorImgUrl"
                      style="
                        width: 50px;
                        height: 50px;
                        background-position: center;
                        background-repeat: no-repeat;
                        border: 1px solid #ddd;
                        background-size: cover;
                      "
                    ></a>
                    <div class="c-16 mg-r-10">
                      <div class="mg-b-0 tx-gray-900 tx-ellipsis2">
                        {{ item.name }}
                      </div>
                      <div class="mg-b-0 d-flex">
                        <span>{{ $t("mall.SPU编号：") }}</span>
                        <span class="tx-gray-900">{{
                          item.sku ? item.sku : "--"
                        }}</span>
                      </div>
                      <div class="mg-b-0 d-flex">
                        <span>{{ $t("mall.供货价：") }}</span>
                        <span class="tx-gray-900"
                          >$t('mall.￥'){{
                            item.min ? Number(item.min).toFixed(2) : "0.00"
                          }}
                          - $t('mall.￥'){{
                            item.max ? Number(item.max).toFixed(2) : "0.00"
                          }}</span
                        >
                      </div>
                    </div>
                    <div v-if="modalMarketProduct.type != 1">
                      <a
                        href="javascript:;"
                        class="tx-info"
                        @click="selectMarketPro(index)"
                        >{{ $t("mall.选择商品") }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-10" style="padding-left: 20px">
                <p class="tx-gray-900 mg-b-10">
                  {{ $t("mall.已选择")
                  }}<span class="tx-bold">{{
                    modalMarketProduct.selectItems.length
                  }}</span
                  >{{ $t("mall.种商品") }}
                </p>
                <div class="">
                  <div
                    style="border-bottom: 1px solid #ddd"
                    class="d-flex tx-12 align-items-center pd-y-5"
                    v-for="(item, index) in modalMarketProduct.selectItems"
                    :key="item.id"
                  >
                    <a
                      class="mg-r-10 img-wrap d-block"
                      href="javascript:;"
                      v-lazy:background-image="item.majorImgUrl"
                      style="
                        width: 50px;
                        height: 50px;
                        background-position: center;
                        background-repeat: no-repeat;
                        border: 1px solid #ddd;
                        background-size: cover;
                      "
                    ></a>
                    <div class="c-16">
                      <div class="mg-b-0 tx-gray-900 tx-ellipsis2">
                        {{ item.name }}
                      </div>
                      <div class="mg-b-0 d-flex">
                        <span>{{ $t("mall.SPU编号：") }}</span>
                        <span class="tx-gray-900">{{
                          item.sku ? item.sku : "--"
                        }}</span>
                      </div>
                      <div class="mg-b-0 d-flex">
                        <span>{{ $t("mall.供货价：") }}</span>
                        <span class="tx-gray-900"
                          >{{ $t("mall.￥")
                          }}{{
                            item.min ? Number(item.min).toFixed(2) : "0.00"
                          }}
                          - {{ $t("mall.￥")
                          }}{{
                            item.max ? Number(item.max).toFixed(2) : "0.00"
                          }}</span
                        >
                      </div>
                    </div>
                    <div v-if="modalMarketProduct.type != 1">
                      <a
                        href="javascript:;"
                        class="tx-danger"
                        @click="removeMarketPro(index)"
                        >{{ $t("mall.删除") }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <innerPagination
                v-if="modalMarketProduct.items.length > 0"
                :cur="modalMarketProduct.page"
                :all="modalMarketProduct.totalPage"
                :size="7"
                @page="gotoPageModal"
              ></innerPagination>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveMarketPro()"
              >
                {{ $t("mall.确定") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("mall.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <confirmComponent
        @del_index_i="deletesFn"
        :modal_id="delAddr.modalId"
        :modal_title="delAddr.title"
        :modal_text="delAddr.text"
        :del_index="delAddr.delIndex"
      ></confirmComponent>
    </div>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //$t('mall.左边栏')
import Header from "./header.vue"; //$t('mall.头')
import Modal from "@components/Modal";
import { pagination } from "@components/pagination.js"; //$t('mall.分页')
import { innerPagination } from "@components/pagination.js"; //$t('mall.分页')
import { confirmComponent } from "@components/components.js"; //$t('mall.删除')确认

export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //$t('mall.左边栏')$t('mall.状态')
      firstLoading: true,
      loading: false,
      page: this.$route.params.page ? this.$route.params.page : 1,
      totalPage: 1,
      rowsPerPage: parseInt(store.get("mall-marketing-rowsPerPage"))
        ? parseInt(store.get("mall-marketing-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50],
      totalCount: 0,
      items: [],
      filterProps: {
        status: "",
        type: "",
        clickType: "",
      },
      modalNewAD: {
        loading: false,
        imgUrl: "",
        uploadType: 1,
        status: "",
        priceRange1: 0,
        priceRange2: "",
        productName: "",
        clickType: "",
        type: "",
        cId: "",
        cIdName: "",
        id: "",
        title: "",
        products: [],
      },
      modalNewADDefault: "{}",
      modalMallLabel: {
        loading: false,
        list: [],
      },
      delAddr: {
        modalId: "modalDelAD",
        title: this.$t("mall.删除"),
        text: this.$t("mall.确定要删除吗"),
        delIndex: "",
      },
      video_url: "",
      scale: false,
      modalMarketProduct: {
        loading: false,
        keyName: "",
        keySpu: "",
        page: 1,
        rowsPerPage: 10,
        totalPage: 0,
        totalCount: 0,
        items: [],
        selectItems: [],
        keySpuCopy: "",
        keySpuName: "",
        type: "",
      },
      modalMarketProductDefault: "{}",
      marketTypeList: {
        1: "mall.选择的产品在二级页面与产品详情页显示",
        2: "mall.选择的产品在首页中部滚动展示",
        3: "mall.选择的产品在首页中部静止展示（序列3）",
        4: "mall.选择的产品在首页中部静止展示（序列2）",
        5: "mall.选择的产品在首页中部静止展示（序列1）",
      },
    };
  },
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
    confirmComponent,
    innerPagination,
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("mall-marketing-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getItems();
    this.modalNewADDefault = JSON.stringify(this.modalNewAD);
    this.modalMarketProductDefault = JSON.stringify(this.modalMarketProduct);
  },
  updated() {},
  methods: {
    openMarketPro(item) {
      this.modalNewAD.products = item.products;
      this.modalMarketProduct = JSON.parse(this.modalMarketProductDefault);
      this.modalMarketProduct.selectItems = this.modalNewAD.products;
      this.getMarketPro();
      $("#modalMarketProduct").modal("show");
      this.modalMarketProduct.type = 1;
    },
    saveMarketPro() {
      $("#modalMarketProduct").modal("hide");
      $("#modalNewAD").modal("show");
      this.modalNewAD.products = this.modalMarketProduct.selectItems;
    },
    removeMarketPro(index) {
      this.modalMarketProduct.selectItems.splice(index, 1);
      ShowTip(this.$t("mall.删除成功"), "success");
      this.modalNewAD.products = this.modalMarketProduct.selectItems;
    },
    selectMarketPro(index) {
      if (
        this.modalNewAD.type == 4 &&
        this.modalNewAD.clickType == 2 &&
        this.modalMarketProduct.selectItems &&
        this.modalMarketProduct.selectItems.length >= 5
      ) {
        ShowTip(this.$t("mall.最多只能选择5个商品"), "danger");
        return;
      }
      this.modalMarketProduct.selectItems.push(
        this.modalMarketProduct.items[index]
      );
      ShowTip(this.$t("mall.选择成功"), "success");
      //$t('mall.去重')
      let hash = {};
      this.modalMarketProduct.selectItems =
        this.modalMarketProduct.selectItems.reduce((item, next) => {
          hash[next.id] ? "" : (hash[next.id] = true && item.push(next));
          return item;
        }, []);
      this.modalNewAD.products = this.modalMarketProduct.selectItems;
    },
    clearKeyModal(type) {
      switch (type) {
        case "spu":
          this.modalMarketProduct.keySpuCopy = this.modalMarketProduct.keySpu =
            "";
          break;
        case "name":
          this.modalMarketProduct.keyNameCopy =
            this.modalMarketProduct.keyName = "";
          break;
      }
      this.modalMarketProduct.page = 1;
      this.getMarketPro();
    },
    gotoPageModal(page) {
      this.modalMarketProduct.page = page;
      this.getMarketPro();
    },
    filtrateModal() {
      this.modalMarketProduct.page = 1;
      this.modalMarketProduct.keySpuCopy = this.modalMarketProduct.keySpu;
      this.modalMarketProduct.keyNameCopy = this.modalMarketProduct.keyName;
      this.getMarketPro();
    },
    modalMarketPro() {
      this.modalMarketProduct = JSON.parse(this.modalMarketProductDefault);
      this.modalMarketProduct.selectItems = this.modalNewAD.products;
      this.getMarketPro();
      $("#modalMarketProduct").modal("show");
      $("#modalNewAD").modal("hide");
    },
    getMarketPro() {
      this.modalMarketProduct.loading = true;
      let params = {
        name: this.modalMarketProduct.keyName,
        page: this.modalMarketProduct.page,
        rowsPerPage: this.modalMarketProduct.rowsPerPage,
        spu: this.modalMarketProduct.keySpu,
      };

      $.api_call("api.SupplierStockSPU.findBySupplier", params, (r) => {
        this.modalMarketProduct.loading = false;
        if (r.ErrorCode == "9999") {
          this.modalMarketProduct.items = [];
          r.Data.Results.forEach((item) => {
            this.modalMarketProduct.items.push(item);
          });
          this.modalMarketProduct.totalPage = r.Data.Pagination.totalPage;
          this.modalMarketProduct.totalCount = r.Data.Pagination.totalCount;
          $("#modalMarketProduct .modal-body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    editAD(item) {
      this.modalNewAD.id = item.id;
      this.modalNewAD.status = item.status;
      this.modalNewAD.priceRange1 = item.paramsJson.min
        ? item.paramsJson.min
        : 0;
      this.modalNewAD.priceRange2 = item.paramsJson.max;
      this.modalNewAD.productName = item.paramsJson.keyword;
      this.modalNewAD.clickType = item.clickType;
      this.modalNewAD.type = item.type;
      this.modalNewAD.cId = item.paramsJson.cId;
      this.modalNewAD.cIdName = item.paramsJson.cName;
      this.modalNewAD.title = item.title;
      this.modalNewAD.products = item.products;
      let vm = this;
      vm.scale = false;
      let img = new Image();
      img.src = this.modalNewAD.imgUrl;
      img.onload = function () {
        if (img.width > img.height) {
          vm.$set(vm, "scale", true);
        }
      };
      $("#modalNewAD").modal("show");
    },
    updateItems(id) {
      this.loading = true;
      $.api_call(
        "api.SupplierMarket.findBySupplier",
        {
          id: id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            this.items.forEach((e, i) => {
              if (e.id == r.Data.Results[0].id) {
                this.items.splice(i, 1, r.Data.Results[0]);
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    deletesFn() {
      //$t('mall.删除')
      this.loading = true;
      $.api_call(
        "api.SupplierMarket.deleteBySupplier",
        {
          id: this.delAddr.delIndex,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            $(`#${this.delAddr.modalId}`).modal("hide");
            ShowTip($t("mall.删除成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    deleteAD(item) {
      this.delAddr.delIndex = item.id;
      $("#" + this.delAddr.modalId).modal("show");
    },
    saveNewADLabel() {
      this.modalMallLabel.list.forEach((e) => {
        if (e.id == this.modalNewAD.cId) {
          this.modalNewAD.cIdName = e.name;
        } else {
          if (e.chlidren && e.chlidren.length > 0) {
            e.chlidren.forEach((s) => {
              if (s.id == this.modalNewAD.cId) {
                this.modalNewAD.cIdName = s.name;
              }
            });
          }
        }
      });
      $("#modalNewAD").modal("show");
      $("#modalMallLabel").modal("hide");
    },
    modalNewADLabel() {
      this.loading = true;
      $.api_call("api.SupplierProductCategorys.findBySupplier", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.modalMallLabel.list = r.Data.Results;
          $("#modalNewAD").modal("hide");
          $("#modalMallLabel").modal("show");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    saveNewAD() {
      if (!this.modalNewAD.status) {
        ShowTip(this.$t("mall.请选择状态"), "danger");
        return;
      }
      let pro = [];
      if (this.modalNewAD.products.length) {
        this.modalNewAD.products.forEach((e) => {
          pro.push(e.sku);
        });
      }
      this.modalNewAD.loading = true;
      let params = {
        type: this.modalNewAD.type,
        clickType: this.modalNewAD.clickType,
        status: this.modalNewAD.status,
        jsons: {
          keyword: this.modalNewAD.productName,
          priceRange: `${this.modalNewAD.priceRange1}-${this.modalNewAD.priceRange2}`,
          cId: this.modalNewAD.cId,
          products: pro,
        },
        title: this.modalNewAD.title,
      };
      let url = !this.modalNewAD.id
        ? "api.SupplierMarket.addBySupplier"
        : "api.SupplierMarket.changeBySupplier";
      let tx = !this.modalNewAD.id
        ? this.$t("mall.添加成功")
        : this.$t("mall.修改成功");
      if (this.modalNewAD.id) {
        params.id = this.modalNewAD.id;
      }
      $.api_call(url, params, (r) => {
        this.modalNewAD.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(tx, "success");
          $("#modalNewAD").modal("hide");
          $("#modalMallLabel").modal("hide");
          if (this.modalNewAD.id) {
            this.updateItems(this.modalNewAD.id);
            return;
          }
          this.getItems();
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    fileClick2() {
      document.getElementById("upload_file_btn3").click();
    },
    fileUpload(el) {
      this.modalNewAD.loading = true;
      $.api_call(
        "api.SupplierMallAD.uploadFiles",
        {
          "@file": el.target.files[0],
        },
        (r) => {
          this.modalNewAD.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalNewAD.imgUrl = r.Data.Results;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    fileClick() {
      document.getElementById("upload_file_btn2").click();
    },
    imgBase64(event) {
      let vm = this;
      let el = event.target;
      if (el.value) {
        //$t('mall.转')base64
        base64Image({
          width: 99999999,
          file: el,
          callback: (rst) => {
            let ext = "";
            let extArr = rst.match(/data:image\/(.*);base64,.*/);
            ext = extArr[1];
            let base64 = rst.split("base64,").pop();
            this.modalNewAD.loading = true;
            $.api_call(
              "api.SupplierMallAD.uploadFiles",
              {
                imgUrlBase64: base64,
                ext: ext,
              },
              (r) => {
                this.modalNewAD.loading = false;
                if (r.ErrorCode == "9999") {
                  this.modalNewAD.imgUrl = r.Data.Results;
                  vm.scale = false;
                  let img = new Image();
                  img.src = this.modalNewAD.imgUrl;
                  img.onload = function () {
                    if (img.width > img.height) {
                      vm.$set(vm, "scale", true);
                    }
                  };
                } else {
                  if (r.ErrorCode == "1002") {
                    userFailure(this);
                  } else {
                    ShowTip(r.Message, "danger");
                  }
                }
              }
            );
          },
        });
      }
    },
    addNew() {
      //$t('mall.打开添加修改')
      this.modalNewAD = JSON.parse(this.modalNewADDefault);
      $("#modalNewAD").modal("show");
    },
    getItems() {
      if (!this.isSysRights("SupplierMarket.findBySupplier")) return;
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        status: this.filterProps.status,
        type: this.filterProps.type,
        clickType: this.filterProps.clickType,
      };
      $.api_call("api.SupplierMarket.findBySupplier", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.firstLoading = false;
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    move(item, type) {
      //$t('mall.上移下移')
      let tx = type == 1 ? this.$t("mall.上移成功") : this.$t("mall.下移成功");
      this.loading = true;
      $.api_call(
        "api.SupplierMarket.moveBySupplier",
        {
          id: item.id,
          type: type,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            ShowTip(tx, "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    clearKey(type) {
      this.filterProps[type] = "";
      this.toPage(1);
    },
    filtrate(status, type, clickType) {
      (this.filterProps = {
        status,
        type,
        clickType,
      }),
        this.toPage(1);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/mall-marketing/" + 1 });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/mall-marketing/" + num });
      if (page == num) {
        this.getItems();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
  },
};
</script>

<style lang="less" scoped>
.body-inner {
  [data-id="datepicker-from"],
  [data-id="datepicker-to"] {
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    color: #495057;
  }
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }
}
.nav.nav-outline {
  padding: 0 15px;
}
</style>